<div class="return-part-content-area">
    <return-preview-form-viewer class="preview-form-viewer"></return-preview-form-viewer>
</div>
<div class="return-part-interaction-area">
    <return-preview-form-list class="preview-form-list"></return-preview-form-list>
</div>